import { Navigate } from 'react-router-dom';
import { useUser } from '../hook/UserContext';

function LoadingScreen() {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{
        minHeight: '100vh',
        background: '#f8f9fa',
      }}
    >
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #ff6600 0%, #ff9a3c 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 24,
          animation: 'mooviPulse 1.6s ease-in-out infinite',
        }}
      >
        <i className="bi bi-car-front-fill text-white" style={{ fontSize: 32 }} />
      </div>

      <div
        style={{
          width: 180,
          height: 4,
          borderRadius: 99,
          background: '#e9ecef',
          overflow: 'hidden',
          marginBottom: 20,
        }}
      >
        <div
          style={{
            height: '100%',
            width: '70%',
            borderRadius: 99,
            background: 'linear-gradient(90deg, #ff6600, #ff9a3c)',
            animation: 'mooviBar 1.4s ease-in-out infinite',
          }}
        />
      </div>

      <p
        className="text-muted"
        style={{
          fontSize: 13,
          letterSpacing: '0.04em',
        }}
      >
        Chargement en cours…
      </p>

      <style>{`
        @keyframes mooviPulse {
          0% {
            box-shadow: 0 0 0 0 rgba(255,102,0,0.35);
            transform: scale(1);
          }

          50% {
            box-shadow: 0 0 0 16px rgba(255,102,0,0);
            transform: scale(1.06);
          }

          100% {
            box-shadow: 0 0 0 0 rgba(255,102,0,0);
            transform: scale(1);
          }
        }

        @keyframes mooviBar {
          0% {
            transform: translateX(-100%);
          }

          50% {
            transform: translateX(50%);
          }

          100% {
            transform: translateX(250%);
          }
        }
      `}</style>
    </div>
  );
}

function EmailNotVerified({ email }) {
  return (
    <div className="vh-100 d-flex justify-content-center align-items-center">
      <div
        className="card shadow-sm p-4 text-center"
        style={{
          maxWidth: '450px',
          width: '100%',
        }}
      >
        <h4 className="mb-3">📩 Compte non vérifié</h4>

        <p className="mb-2">Votre compte n'est pas encore activé.</p>

        <p className="mb-3">Un email de confirmation a été envoyé à :</p>

        <p className="fw-bold text-primary">{email}</p>

        <p className="mt-3 text-muted" style={{ fontSize: 14 }}>
          Veuillez vérifier votre boîte mail et vos spams pour activer votre compte.
        </p>
      </div>
    </div>
  );
}

const PrivateRoute = ({ Component }) => {
  const { user, loading, isAuthenticated } = useUser();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/signin" replace />;
  }

  if (user.role !== 'user') {
    return <Navigate to="/signin" replace />;
  }

  if (user.verified === false) {
    return <EmailNotVerified email={user.email} />;
  }

  return <Component />;
};

export default PrivateRoute;
